/* Shared shell for the match-control dialogs (Migrate, Rehost, Restore backup, Forfeit match/map,
 * Remove forfeit): icon + title header, scrolling body, button row. Esc / backdrop click close it
 * (not while `busy`). Portalled to <body> so the transformed page wrapper can't offset it. */
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import McIcon from './mcIcons';
import './actionModal.css';

const TONES = { cyan: '#22d3ee', violet: '#a78bfa', amber: '#fbbf24', red: '#f87171', green: '#34d399', neutral: '#a1a1b5' };

export default function ActionModal({ icon, tone = 'cyan', title, subtitle, width = 480, busy = false, onClose, footer, children }) {
  const { t } = useTranslation();

  useEffect(() => {
    // Esc on a confirm opened from this dialog closes only the confirm
    const onKey = (e) => { if (e.key === 'Escape' && !busy && !document.querySelector('.cf-backdrop')) onClose && onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [busy, onClose]);

  return createPortal(
    <div className="am-overlay" onMouseDown={e => { if (e.target === e.currentTarget && !busy && onClose) onClose(); }}>
      <div className="am-modal" role="dialog" aria-modal="true" aria-label={title} style={{ '--am': TONES[tone] || tone, maxWidth: width }}>
        <div className="am-head">
          <span className="am-head-icon"><McIcon name={icon} size={16} /></span>
          <div className="am-head-text">
            <div className="am-title">{title}</div>
            {subtitle && <div className="am-sub">{subtitle}</div>}
          </div>
          <button type="button" className="am-x" onClick={onClose} disabled={busy} aria-label={t('common.close', 'Close')}>×</button>
        </div>
        <div className="am-body">{children}</div>
        {footer && <div className="am-actions">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}
